export default __webpack_public_path__ + "media/images/temporary/famous-1-94338d059365986bf43394faef2d42d4.jpg";